import { useCallback, useEffect } from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router';

import { TournamentPageLayout } from 'targets/web/modules/display/components/tournament/TournamentPageLayout/TournamentPageLayout';

export const TournamentDisplayPageLayout = () => {
  const { locationName } = useParams();
  const location = useLocation();

  const toggleFullScreen = useCallback(() => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }, []);

  useEffect(() => {
    const fullscreenHandler = (event: KeyboardEvent) => {
      if (event.key === 'f') {
        toggleFullScreen();
      }
    };

    document.addEventListener('keydown', fullscreenHandler);

    return () => {
      document.removeEventListener('keydown', fullscreenHandler);
    };
  }, [toggleFullScreen]);

  const parts = location.pathname.split('/').filter(Boolean);
  if (!locationName || parts.length < 1) {
    return <Navigate to="/404" />;
  }

  return (
    <TournamentPageLayout>
      <Outlet />
    </TournamentPageLayout>
  );
};
